import { Component, OnInit } from '@angular/core';
import { routesData } from 'src/app/shared/resources/routes.constant';
import { RegExps } from 'src/app/shared/resources/regexps.constant';
import {
  Validators,
  UntypedFormBuilder,
  UntypedFormGroup
} from '@angular/forms';
import { CustomerDataService } from 'src/app/shared/services/customer-data.service';
import { Router } from '@angular/router';
import { InputCurrencyPipe } from 'src/app/shared/pipes/input-currency.pipe';
import { EnumStepFunctions } from 'src/app/shared/enums/step-functions.enum';
import { AnalyticService } from 'src/app/shared/services/analytic.service';
import { CustomValidators } from 'src/app/shared/validators/custom-validators.validators';

@Component({
  selector: 'app-finantial-information',
  templateUrl: './finantial-information.component.html',
  styleUrls: ['./finantial-information.component.scss']
})
export class FinantialInformationComponent implements OnInit {
  public finantialInformationForm: UntypedFormGroup = {} as UntypedFormGroup;
  public monthlyIncome: string = '';
  public montlyExpenses: string = '';
  public assetsnumber: string = '';
  public liabilitiesNumber: string = '';
  public name: string = '';
  public opTypes = [
    { value: 0, viewValue: 'Ninguna' },
    { value: 6, viewValue: 'Envío de giros' },
    { value: 2, viewValue: 'Exportaciones' },
    { value: 1, viewValue: 'Importaciones' },
    { value: 3, viewValue: 'Inversiones' },
    { value: 7, viewValue: 'Pago de servicios' },
    { value: 4, viewValue: 'Prestamos' },
    { value: 5, viewValue: 'Recepción de giros' }
  ];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private customerDataService: CustomerDataService,
    private currencyPipe: InputCurrencyPipe,
    public analytic: AnalyticService
  ) {}

  ngOnInit(): void {
    this.name = this.customerDataService.customerData.firstName;

    this.finantialInformationForm = this.formBuilder.group({
      activeExpenses: ['', Validators.required],
      passiveExpenses: ['', Validators.required],
      monthlyExpenses: ['', Validators.required],
      monthlyIncome: [
        '',
        [
          Validators.required,
          CustomValidators.biggerThan(9999),
          CustomValidators.lesserThan(10000000000)
        ]
      ],
      operationType: ['', Validators.required],
      additionalDataQuestion: ['', Validators.required]
    });

    if (this.customerDataService.customerData.client) {
      const expenses =
        +this.customerDataService.customerData[EnumStepFunctions.StepReadCrm]
          .montlyExpenses;

      this.montlyExpenses = this.currencyPipe.transform(
        !expenses ? '' : expenses.toString()
      );

      const assets =
        +this.customerDataService.customerData[EnumStepFunctions.StepReadCrm]
          .assetsnumber;

      this.assetsnumber = this.currencyPipe.transform(
        !assets ? '' : assets.toString()
      );

      const liabilities =
        +this.customerDataService.customerData[EnumStepFunctions.StepReadCrm]
          .liabilitiesNumber;

      this.liabilitiesNumber = this.currencyPipe.transform(
        !liabilities ? '' : liabilities.toString()
      );

      const income =
        +this.customerDataService.customerData[EnumStepFunctions.StepReadCrm]
          .employmentHistoryList[0]?.incomeAmount;

      this.monthlyIncome = this.currencyPipe.transform(
        !income ? '' : income.toString()
      );

      this.finantialInformationForm.controls['monthlyExpenses'].setValue(
        this.montlyExpenses
      );
      this.finantialInformationForm.controls['activeExpenses'].setValue(
        this.assetsnumber
      );
      this.finantialInformationForm.controls['passiveExpenses'].setValue(
        this.liabilitiesNumber
      );
      this.finantialInformationForm.controls['monthlyIncome'].setValue(
        this.monthlyIncome
      );
    }
  }

  onSubmit(): void {
    try {
      if (this.finantialInformationForm.valid) {
        let rest: any;
        [, ...rest] =
          this.customerDataService.customerData[
            EnumStepFunctions.StepReadCrm
          ].employmentHistoryList;

        const incomeArray = [
          {
            ...this.customerDataService.customerData[
              EnumStepFunctions.StepReadCrm
            ].employmentHistoryList[0],
            incomeAmount: +this.finantialInformationForm.controls[
              'monthlyIncome'
            ].value.replace(RegExps.NOT_NUMBERS, '')
          },
          ...rest
        ];

        this.customerDataService.customerData = {
          ...this.customerDataService.customerData,
          ...{
            [EnumStepFunctions.StepReadCrm]: {
              ...this.customerDataService.customerData[
                EnumStepFunctions.StepReadCrm
              ],
              montlyExpenses: +this.finantialInformationForm.controls[
                'monthlyExpenses'
              ].value.replace(RegExps.NOT_NUMBERS, ''),
              assetsnumber: +this.finantialInformationForm.controls[
                'activeExpenses'
              ].value.replace(RegExps.NOT_NUMBERS, ''),
              liabilitiesNumber: +this.finantialInformationForm.controls[
                'passiveExpenses'
              ].value.replace(RegExps.NOT_NUMBERS, ''),
              internacionalTransactionId:
                this.finantialInformationForm.controls['operationType']
                  .value === 0
                  ? 'N'
                  : 'S',
              acctCurrencyForeignInd:
                this.finantialInformationForm.controls['additionalDataQuestion']
                  .value === 'true'
                  ? 'S'
                  : 'N',
              employmentHistoryList: incomeArray
            },
            customerForeignTransactionType:
              this.finantialInformationForm.controls[
                'operationType'
              ].value.toString()
          }
        };

        if (
          this.finantialInformationForm.controls['additionalDataQuestion']
            .value === 'true'
        ) {
          this.router.navigate([
            routesData.FOREIGN_CURRENCY_MOVEMENTS.redirectPath
          ]);
        } else {
          this.router.navigate([routesData.ACCOUNT_SETTINGS.redirectPath]);
        }
      }
    } catch (error) {
      let errorMessage = '';
      if (error?.message !== undefined) {
        errorMessage = error.message;
      }
      this.analytic.uTagLinkError(
        'Error catch submit información financiera ' + errorMessage,
        'error_tech_page'
      );
      this.router.navigate([routesData.ERRORS.GENERAL_ERROR.redirectPath]);
    }
  }
}
